var map = {
  "./da.json": [
    "58147",
    [
      4448
    ]
  ],
  "./fi.json": [
    "99849",
    [
      53234
    ]
  ],
  "./sv.json": [
    "7053",
    [
      7326
    ]
  ],
  "./ja.json": [
    "99325",
    [
      85902
    ]
  ],
  "./lt.json": [
    "75844",
    [
      42981
    ]
  ],
  "./sl.json": [
    "16315",
    [
      99176
    ]
  ],
  "./fr.json": [
    "68964",
    [
      98917
    ]
  ],
  "./es.json": [
    "13632",
    [
      19097
    ]
  ],
  "./no.json": [
    "18859",
    [
      91032
    ]
  ],
  "./cs.json": [
    "18670",
    [
      61731
    ]
  ],
  "./en.json": [
    "84023",
    [
      39836
    ]
  ],
  "./description/en.json": [
    "1188",
    [
      28613
    ]
  ],
  "./pl.json": [
    "67616",
    [
      90841
    ]
  ],
  "./hu.json": [
    "31987",
    [
      93008
    ]
  ],
  "./nl.json": [
    "75578",
    [
      85479
    ]
  ],
  "./de.json": [
    "35407",
    [
      76100
    ]
  ],
  "./pt.json": [
    "67016",
    [
      29361
    ]
  ],
  "./it.json": [
    "33661",
    [
      84942
    ]
  ],
  "./et.json": [
    "34185",
    [
      35922
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 26553;
module.exports = __rspack_async_context;
